// extracted by mini-css-extract-plugin
module.exports = {"selectableProductCard":"_1qE7RC"};